import api from '../../services/api';

export const parentApi = {
  completeActivation: (token, password) =>
    api.post('/api/parent/activation/complete', { token, password }),
  me: () => api.get('/api/parent/me'),
  updateMe: (payload) => api.patch('/api/parent/me', payload),
  changePassword: (currentPassword, newPassword) =>
    api.post('/api/parent/change-password', { currentPassword, newPassword }),
  children: () => api.get('/api/parent/children'),
  batches: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/batches`),
  today: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/today`),
  contacts: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/contacts`),
  session: (studentId, sessionId) =>
    api.get(`/api/parent/children/${encodeURIComponent(studentId)}/sessions/${encodeURIComponent(sessionId)}`),
  homework: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/homework`),
  submitHomework: (studentId, sessionId, formData) =>
    api.post(
      `/api/parent/children/${encodeURIComponent(studentId)}/homework/${encodeURIComponent(sessionId)}`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    ),
  upcomingSessions: (studentId) =>
    api.get(`/api/parent/children/${encodeURIComponent(studentId)}/upcoming-sessions`),
  leave: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/leave`),
  applyLeave: (studentId, payload) =>
    api.post(`/api/parent/children/${encodeURIComponent(studentId)}/leave`, payload),
  messages: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/messages`),
  thread: (studentId, threadId) =>
    api.get(`/api/parent/children/${encodeURIComponent(studentId)}/messages/${encodeURIComponent(threadId)}`),
  createMessage: (studentId, formData) =>
    api.post(`/api/parent/children/${encodeURIComponent(studentId)}/messages`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
  replyMessage: (studentId, threadId, formData) =>
    api.post(
      `/api/parent/children/${encodeURIComponent(studentId)}/messages/${encodeURIComponent(threadId)}/reply`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    ),
  requests: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/requests`),
  reports: (studentId) => api.get(`/api/parent/children/${encodeURIComponent(studentId)}/reports`),
  reportLink: (studentId, reportId) =>
    api.get(`/api/parent/children/${encodeURIComponent(studentId)}/reports/${encodeURIComponent(reportId)}/link`),
};

export const familyStaffApi = {
  listTeacher: () => api.get('/api/teacher/family-messages'),
  getTeacher: (id) => api.get(`/api/teacher/family-messages/${encodeURIComponent(id)}`),
  replyTeacher: (id, body) => api.post(`/api/teacher/family-messages/${encodeURIComponent(id)}/reply`, { body }),
  reviewHomework: (id) => api.post(`/api/teacher/family-messages/homework/${encodeURIComponent(id)}/review`),
  listRm: () => api.get('/api/rm/family-messages'),
  getRm: (id) => api.get(`/api/rm/family-messages/${encodeURIComponent(id)}`),
  replyRm: (id, body) => api.post(`/api/rm/family-messages/${encodeURIComponent(id)}/reply`, { body }),
};
